module.exports = __webpack_public_path__ + "img/frasco_cili_1000.47bc5194.png";